import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateInstalledProductMutationVariables = Types.Exact<{
  input: Types.CreateInstalledProductInput;
}>;


export type CreateInstalledProductMutation = { __typename?: 'mutation_root', create_installed_product?: { __typename?: 'CreateInstalledProductOutput', success: boolean, installed_product_id?: string | null, error?: string | null, created_installed_product?: { __typename?: 'installed_products_ActionType', created_at?: any | null, id: any, installation_date: any, location?: string | null, partition_id?: string | null, photo_link?: string | null, product_id: any, product_notes?: string | null, product_serial?: string | null, property_id: any, warranty_expiration_date?: any | null, warranty_status: string } | null } | null };


export const CreateInstalledProductDocument = gql`
    mutation createInstalledProduct($input: CreateInstalledProductInput!) {
  create_installed_product(input: $input) {
    success
    installed_product_id
    error
    created_installed_product {
      created_at
      id
      installation_date
      location
      partition_id
      photo_link
      product_id
      product_notes
      product_serial
      property_id
      warranty_expiration_date
      warranty_status
    }
  }
}
    `;
export type CreateInstalledProductMutationFn = Apollo.MutationFunction<CreateInstalledProductMutation, CreateInstalledProductMutationVariables>;

/**
 * __useCreateInstalledProductMutation__
 *
 * To run a mutation, you first call `useCreateInstalledProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInstalledProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInstalledProductMutation, { data, loading, error }] = useCreateInstalledProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInstalledProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateInstalledProductMutation, CreateInstalledProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInstalledProductMutation, CreateInstalledProductMutationVariables>(CreateInstalledProductDocument, options);
      }
export type CreateInstalledProductMutationHookResult = ReturnType<typeof useCreateInstalledProductMutation>;
export type CreateInstalledProductMutationResult = Apollo.MutationResult<CreateInstalledProductMutation>;
export type CreateInstalledProductMutationOptions = Apollo.BaseMutationOptions<CreateInstalledProductMutation, CreateInstalledProductMutationVariables>;